import React from "react";
import { connect } from "react-redux";
import { Card } from "antd";
import SummaryHeader from "components/header/SummaryHeader";
import { FileText } from "lucide-react";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import LeaveRequestTab from "./components/LeaveRequestTab";

const LeaveRequests = () => {
  return (
    <div className="flex flex-col gap-6">
      <SummaryHeader
        title="Leave Request Management"
        icon={FileText}
        description="Review and manage employee leave requests"
        color="green"
        rightNav={
          <div className="flex items-center gap-6 flex-shrink-0">
            <div className="text-right">
              <p className="text-emerald-100/80 text-[12px] mb-1">
                Pending Requests
              </p>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
                <p className="text-[28px] font-bold text-white">3</p>
              </div>
            </div>
          </div>
        }
      />

      <Card className="rounded-xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <SearchBar
            placeholder="Search by name, ID, or position..."
            className="h-1"
          />
          <SelectOption
            placeholder="All Leave Types"
            options={[
              { label: "All Leave Types", value: 0 },
              { label: "Annual Leave", value: 1 },
              { label: "Sick Leave", value: 2 },
              { label: "Emergency Leave", value: 3 },
            ]}
          />
        </div>
      </Card>

	  <LeaveRequestTab/>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveRequests);
